<template>
      <div class="flex ">
         <div>
             温馨提示：
         </div>   
         <div>
             <p>1.支持 png、jpg、rar、zip、7z格式的文件</p>
             <p>2.单次上传文件大小不能超过10M</p>
             <p>3.多人共用文件时，请选择公用文件的员工，点击多人公用文件上传，上传成功后，每名员工都将保存一份对应的文件</p>
             <p>4.如需上传附件人员不在上述人员范围内，请点击 ”选取其他人员</p>
         </div>
      </div>
</template>

<script>
    export default {
        name: "sbsp-form-file-details",
    }
</script>

<style scoped >
    .flex{
        display:flex;
    }
    .flex>div{
          font-weight:500;
    }
    .flex *{
        font-size:13px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:18px;
       
    }
    .flex p{
        margin-bottom:16px;
    }
</style>
